import {BaseVueEntity} from "@/entities/BaseVueEntity";
import {compareProperty} from "@/utils";

export class Role  extends BaseVueEntity{

  private readonly _id: string;
  private readonly _displayNameSingular: string;
  private readonly _displayNamePlural : string;
  private readonly _sortOrder: string;



  constructor(entity) {
    super();
    this._id = entity.ID;
    this._displayNamePlural = entity.ANZEIGETEXT_PL;
    this._displayNameSingular = entity.ANZEIGETEXT_SG;
    this._sortOrder = entity.S_ORDER;
  }



  static comparator(a: Role, b: Role): number {
    return compareProperty(a._sortOrder, b._sortOrder);
  }


  get id(): string {
    return this._id;
  }

  get displayNameSingular(): string {
    return this._displayNameSingular;
  }

  get displayNamePlural(): string {
    return this._displayNamePlural;
  }

  get sortOrder(): string {
    return this._sortOrder;
  }
}
